import { useCallback, useEffect, useRef, type ReactNode } from 'react'

import { RecordReachProvider, type RecordReachLookup } from '@/shared/access'
import { parseCursorPage } from '@/shared/api/paging'
import { useApiClient } from '@/shared/api/use-api-client'

import { parsePlanSummary, planRoute, plansApi } from './plan'

/**
 * Links a subscription plan's name only for a caller who may open it: Find Plans, asked for the
 * linked ids, answers with those in their plan read reach, as Plan Details does.
 */
export function PlanReachProvider(props: { readonly children: ReactNode }) {
  const client = useApiClient()
  // Kept current without changing the lookup, which would ask again: the client changes when sign-in settles.
  const api = useRef(client)
  useEffect(() => {
    api.current = client
  }, [client])

  const lookup = useCallback<RecordReachLookup>(async (ids) => {
    const query = new URLSearchParams({ ids: ids.join(','), limit: String(ids.length) })
    const found = parseCursorPage(await api.current.get(`${plansApi}?${query.toString()}`), parsePlanSummary)
    return new Set(found.data.map((plan) => plan.id))
  }, [])

  return (
    <RecordReachProvider route={planRoute} lookup={lookup}>
      {props.children}
    </RecordReachProvider>
  )
}
